import {Button} from "@/components/ui/button";
import {PublicPageShell} from "@/src/modules/core/components";
import {LOGO_URL_DESKTOP} from "@/src/modules/core/utils/constants";
import {useStoredSession} from "@/src/modules/auth/store/session";
import useGeolocation from "@/src/modules/core/hooks/use-geolocation";
import {isGeolocationPermissionDenied} from "@/src/modules/core/lib/geolocation-service";
import {useEffect} from "react";
import {Link, useNavigate} from "react-router-dom";

export default function LocationDenied() {
  const session = useStoredSession();
  const {loading} = useGeolocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isGeolocationPermissionDenied()) {
      navigate("/");
    }
  }, [loading, navigate]);

  return (
    <PublicPageShell>
      <div className="rounded-lg bg-background p-6 shadow-lg sm:p-8">
          <div className="flex flex-col items-center mb-8">
            <div className="flex items-center justify-center h-16 w-16 rounded-full ">
              <img src={LOGO_URL_DESKTOP} alt="Image" height="100" />
            </div>
            <h1 className="text-2xl font-bold text-slate-800">STARSPRO</h1>
            <p className="text-slate-500">Security Management System</p>
          </div>

          <h2 className="text-xl font-semibold text-slate-800 mb-2 text-center">
            Location services are disabled
          </h2>
          <p className="text-slate-500 mb-4 text-center">
            Please enable location services settings to use this application.
          </p>
          <Button className="w-full" onClick={() => window.location.reload()}>
            Reload
          </Button>
          <Link to={session ? "/" : "/login"} className="mt-2 ml-auto mr-auto block w-fit">
            <Button variant="link" className="text-slate-500 text-xs">
              Go back to {session ? "home" : "login"}
            </Button>
          </Link>
        </div>

      <div className="mt-6 text-center text-xs text-muted-foreground">
        &copy; {new Date().getFullYear()} STARSPRO. All rights reserved.
      </div>
    </PublicPageShell>
  );
}
